'use client';

import { ENGLISH_IQ_EVENTS } from '@repo/analytics';
import {
  appendShareParams,
  buildAppDownloadWebUrl,
  buildEnglishIqResultWebUrl,
} from '@repo/config';
import type { IEnglishIqResult } from '@repo/sdk';
import { DEFAULT_LOCALE } from '@repo/web-chrome/i18n';
import { recordInstallIntent, trackEvent } from '@repo/web-chrome/lib/analytics';
import { useState } from 'react';

export function useEnglishIqResultActions(
  locale: string,
  result: IEnglishIqResult,
  copiedLabel: string,
  shareTitle: string,
) {
  const [shareLabel, setShareLabel] = useState<string | null>(null);
  const localeArgument = locale === DEFAULT_LOCALE ? undefined : locale;
  const shareUrl = appendShareParams(buildEnglishIqResultWebUrl(result.shareId, localeArgument), {
    campaign: 'english_iq_result',
    content: result.shareId,
    source: 'web',
  });
  const installUrl = appendShareParams(buildAppDownloadWebUrl(locale), {
    campaign: 'english_iq_install',
    content: `${result.score}:${result.shareId}`,
    source: 'web',
  });

  const share = async (): Promise<void> => {
    trackEvent(ENGLISH_IQ_EVENTS.shareTap, { score: result.score, surface: 'web' });
    if (navigator.share) {
      await navigator.share({ title: shareTitle, url: shareUrl }).catch(() => {});
      return;
    }
    await navigator.clipboard.writeText(shareUrl);
    setShareLabel(copiedLabel);
  };

  const recordInstall = (): void => {
    trackEvent(ENGLISH_IQ_EVENTS.installCta, { score: result.score, surface: 'web' });
    recordInstallIntent('web');
  };

  return { installUrl, recordInstall, share, shareLabel };
}
